<div class="container">
  <h2 class="mb-4">Vendors List</h2>

  <div class="custom-table-wrapper">
    <table class="table table-bordered custom-table">
      <thead>
        <tr>
          <th>Vendor Name</th>
          <th>GST No</th>
          <th>Address</th>
          <th>Contact No</th>
          <th>Actions</th>
        </tr>

        <!-- Filter Row -->
        <tr>
          <th>
            <input
              type="text"
              class="form-control"
              placeholder="Search Vendor"
              [(ngModel)]="filter.vendorName"
              (input)="applyFilters()"
            />
          </th>

          <th>
            <input
              type="text"
              class="form-control"
              placeholder="Search GST"
              [(ngModel)]="filter.gstNo"
              (input)="applyFilters()"
            />
          </th>

          <th>
            <input
              type="text"
              class="form-control"
              placeholder="Search Address"
              [(ngModel)]="filter.address"
              (input)="applyFilters()"
            />
          </th>

          <th>
            <input
              type="text"
              class="form-control"
              placeholder="Search Contact"
              [(ngModel)]="filter.contactNo"
              (input)="applyFilters()"
            />
          </th>

          <th>
            <button
              (click)="resetFilters()"
              class="btn btn-primary btn-sm"
            >
              <i class="fa fa-x" aria-hidden="true"></i>
            </button>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let vendor of filteredVendorList">
          <td>{{ vendor.vendorName }}</td>
          <td>{{ vendor.gstNo }}</td>
          <td>{{ vendor.address }}</td>
          <td>{{ vendor.contactNo }}</td>

          <td>
            <button
              class="btn btn-secondary btn-sm"
              (click)="updateVendor(vendor)"
              [disabled]="!hasPermission('VendorsAddNewVendorPermission')"
            >
              Update
            </button>

            <button
              class="btn btn-danger btn-sm"
              (click)="deleteVendor(vendor)"
            >
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>